import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { IDirectionDetail } from 'entities/ticket/ui/direction-detail'

import { previewPdfUrl } from 'shared/lib/pdf-preview'
import { Paper } from 'shared/ui/paper'

import { OneSegmentFlight } from './components'
import s from './styles.module.scss'

interface Props {
  title?: string
  receiptUrl?: string
  ticketsDirections: IDirectionDetail[]
  padding?: number[]
}

export const FlightInfoOrders = ({
  title,
  receiptUrl,
  ticketsDirections,
  padding = [12, 14],
}: Props) => {
  const { t } = useTranslation()

  const btnHandlerOpenPDF = (link?: string) => {
    previewPdfUrl(link)
  }

  return (
    <Paper
      padding={padding}
      radius={16}
    >
      {title && <p className={clsx(s.title, 'semi-bold-16')}>{title}</p>}

      <div className={s.container}>
        {ticketsDirections?.map((direction, index) => (
          <div
            key={`${direction?.flyItems?.[0]?.flight}-${index}`}
            className={s.direction}
          >
            <OneSegmentFlight
              direction={index}
              ticket={direction}
            />
          </div>
        ))}
      </div>

      {receiptUrl && (
        <p
          className={clsx(s.linkReceipt, 'medium-14')}
          onClick={() => btnHandlerOpenPDF(receiptUrl)}
        >
          {t('open_mk')}
        </p>
      )}
    </Paper>
  )
}
